import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ContentChild, ChangeDetectorRef } from '@angular/core';

import { TdFileInputComponent, TdFileInputLabelDirective } from '../file-input/file-input.component';
export class TdFileUploadComponent {
private _multiple: boolean = false;
private _disabled: boolean = false;

  files: FileList | File;

   inputLabel: TdFileInputLabelDirective;
/**
 * defaultColor?: string
 * Sets browse button color. Uses same color palette accepted as [mdButton] and defaults to 'primary'.
 */
defaultColor: string = 'primary';
/**
 * activeColor?: string
 * Sets upload button color. Uses same color palette accepted as [mdButton] and defaults to 'accent'.
 */
activeColor: string = 'accent';
/**
 * cancelColor?: string
 * Sets cancel button color. Uses same color palette accepted as [mdButton] and defaults to 'warn'.
 */
cancelColor: string = 'warn';
/**
 * multiple?: boolean
 * Sets if multiple files can be dropped/selected at once in [TdFileUploadComponent].
 * @param {?} multiple
 * @return {?}
 */
set multiple(multiple: string | boolean) {
    this._multiple = multiple !== '' ? (multiple === 'true' || multiple === true) : true;
  }
/**
 * @return {?}
 */
get multiple(): string | boolean {
    return this._multiple;
  }
/**
 * accept?: string
 * Sets files accepted when opening the file browser dialog.
 * Same as 'accept' attribute in <input/> element.
 */
accept: string;
/**
 * disabled?: boolean
 * Disables [TdFileUploadComponent] and clears selected/dropped files.
 * @param {?} disabled
 * @return {?}
 */
set disabled(disabled: boolean) {
    if (disabled) {
      this.cancel();
    }
    this._disabled = disabled;
  }
/**
 * @return {?}
 */
get disabled(): boolean {
    return this._disabled;
  }
/**
 * select?: function
 * Event emitted when a file is selecte.
 * Emits a [File | FileList] object.
 */
onSelect: EventEmitter<File | FileList> = new EventEmitter<File | FileList>();
/**
 * upload?: function
 * Event emitted when upload button is clicked.
 * Emits a [File | FileList] object.
 */
onUpload: EventEmitter<File | FileList> = new EventEmitter<File | FileList>();
/**
 * cancel?: function
 * Event emitted when cancel button is clicked.
 */
onCancel: EventEmitter<void> = new EventEmitter<void>();
/**
 * @param {?} _changeDetectorRef
 */
constructor(private _changeDetectorRef: ChangeDetectorRef) {

  }
/**
 * Method executed when upload button is clicked.
 * @return {?}
 */
uploadPressed(): void {
    if (this.files) {
      this.onUpload.emit(this.files);
    }
  }
/**
 * Method executed when a file is selected.
 * @param {?} files
 * @return {?}
 */
handleSelect(files: File | FileList): void {
    this.files = files;
    this.onSelect.emit(files);
    this._changeDetectorRef.markForCheck();
  }
/**
 * Methods executed when cancel button is clicked.
 * Clears files.
 * @return {?}
 */
cancel(): void {
    this.files = undefined;
    this.onCancel.emit(undefined);
    this._changeDetectorRef.markForCheck();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'td-file-upload',
  styleUrls: ['./file-upload.component.css'],
  templateUrl: './file-upload.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'inputLabel': [{ type: ContentChild, args: [TdFileInputLabelDirective, ] },],
'defaultColor': [{ type: Input, args: ['defaultColor', ] },],
'activeColor': [{ type: Input, args: ['activeColor', ] },],
'cancelColor': [{ type: Input, args: ['cancelColor', ] },],
'multiple': [{ type: Input, args: ['multiple', ] },],
'accept': [{ type: Input, args: ['accept', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'onSelect': [{ type: Output, args: ['select', ] },],
'onUpload': [{ type: Output, args: ['upload', ] },],
'onCancel': [{ type: Output, args: ['cancel', ] },],
};
}

function TdFileUploadComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdFileUploadComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdFileUploadComponent.ctorParameters;
/** @type {?} */
TdFileUploadComponent.propDecorators;
/** @type {?} */
TdFileUploadComponent.prototype._multiple;
/** @type {?} */
TdFileUploadComponent.prototype._disabled;
/** @type {?} */
TdFileUploadComponent.prototype.files;
/** @type {?} */
TdFileUploadComponent.prototype.inputLabel;
/**
 * defaultColor?: string
 * Sets browse button color. Uses same color palette accepted as [mdButton] and defaults to 'primary'.
 * @type {?}
 */
TdFileUploadComponent.prototype.defaultColor;
/**
 * activeColor?: string
 * Sets upload button color. Uses same color palette accepted as [mdButton] and defaults to 'accent'.
 * @type {?}
 */
TdFileUploadComponent.prototype.activeColor;
/**
 * cancelColor?: string
 * Sets cancel button color. Uses same color palette accepted as [mdButton] and defaults to 'warn'.
 * @type {?}
 */
TdFileUploadComponent.prototype.cancelColor;
/**
 * accept?: string
 * Sets files accepted when opening the file browser dialog.
 * Same as 'accept' attribute in <input/> element.
 * @type {?}
 */
TdFileUploadComponent.prototype.accept;
/**
 * select?: function
 * Event emitted when a file is selecte.
 * Emits a [File | FileList] object.
 * @type {?}
 */
TdFileUploadComponent.prototype.onSelect;
/**
 * upload?: function
 * Event emitted when upload button is clicked.
 * Emits a [File | FileList] object.
 * @type {?}
 */
TdFileUploadComponent.prototype.onUpload;
/**
 * cancel?: function
 * Event emitted when cancel button is clicked.
 * @type {?}
 */
TdFileUploadComponent.prototype.onCancel;
/** @type {?} */
TdFileUploadComponent.prototype._changeDetectorRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
